import graphql__afa6b8ab768b65f069f5 from "./__generated__/CardStep_step.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ProgressBar from "../Utils/ProgressBar";
import { useDateRangeMessage } from "../Utils/dateRangeMessage";

const CardStep = props => {
  const step = useFragment(CardStep_step, props.step);
  const { name, startDate, endDate, isCurrent, position } = step;

  const dateRangeMessage = useDateRangeMessage();
  const dateRange = dateRangeMessage(startDate, endDate);

  const className = classNames([
    "box",
    "card-step",
    props.className,
    {
      "opacity-inactive": !isCurrent
    }
  ]);

  return (
    <div className={className}>
      <div className="d-flex align-items-center">
        <div className="margin-right-xs">
          <div className="bg-primary card-rounded-label d-flex align-content-center">
            {position + 1}
          </div>
        </div>

        <div className="flex-1">
          {name}
          <div className="d-flex align-items-center text-legend text-primary">
            {dateRange}
          </div>

          <ProgressBar
            startDate={startDate}
            endDate={endDate}
            className="margin-top-xxs"
          />
        </div>
      </div>
    </div>
  );
};

const CardStep_step = graphql__afa6b8ab768b65f069f5;

export default CardStep;
